export default __webpack_public_path__ + "static/media/pic-1.ad1ed7ee.jpg";